module.exports = {
    DELETE_TICKET: "Are you sure you want to delete this ticket?",
    DELETE_TICKET_COMMENT: "Are you sure you want to delete this comment?",
}